// AUTO-GENERADO por scripts/generate-build-id.js — no editar a mano.
// Se regenera en cada `npm run build`. Sirve de cache-buster de los JSON
// de i18n (./assets/i18n/*.json?v=BUILD_ID) para que los usuarios vean las
// traducciones nuevas tras un deploy sin tener que limpiar caché manualmente.
export const BUILD_ID = '8f20410445';
